import React, { useEffect, useRef, useState } from "react";
import pPhoto from "../assets/pp.jpeg";
import {
  FaIdCard,
  FaMapMarkerAlt,
  FaRegEnvelope,
  FaGithub,
  FaLinkedin,
  FaMedium,
} from "react-icons/fa";

import js from "../assets/scrollMenu/js.png";
import reactNative from "../assets/scrollMenu/react-native-1.svg";
import react2 from "../assets/scrollMenu/react2.png";
import vue from "../assets/scrollMenu/vue.png";
import csharp from "../assets/scrollMenu/Csharp.png";
import netCore from "../assets/scrollMenu/NET_Core.png";
import unity from "../assets/scrollMenu/Unity.png";
import unityDark from "../assets/scrollMenu/UnityLogo.png";
// import java from "../assets/scrollMenu/java.png"; // Removed unused import
import androidImg from "../assets/scrollMenu/android.png";
import jira from "../assets/scrollMenu/Jira.png";
import firebaseImg from "../assets/scrollMenu/Firebase.png";
import sql from "../assets/scrollMenu/sql.png";
import iosImg from "../assets/scrollMenu/ios.png";
import androidIm from "../assets/scrollMenu/andro.png";
import iosDark from "../assets/scrollMenu/iosDark.png";

function Home({ darkMode }) {
  const scrollRef = useRef(null);
  const [displayedText, setDisplayedText] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  const roles = [
    "Full-Stack Developer",
    "React & React Native Dev",
    "Mobile App Developer",
    ".NET Core API Developer",
  ];
  const [roleIndex, setRoleIndex] = useState(0);

  // Typewriter efekti
  useEffect(() => {
    setIsTyping(true);
    let currentIndex = 0;
    const currentRole = roles[roleIndex];
    const typingInterval = setInterval(() => {
      if (currentIndex <= currentRole.length) {
        setDisplayedText(currentRole.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
        setIsTyping(false);
        // Pause then erase and move to next role
        setTimeout(() => {
          let eraseIndex = currentRole.length;
          const eraseInterval = setInterval(() => {
            if (eraseIndex >= 0) {
              setDisplayedText(currentRole.slice(0, eraseIndex));
              eraseIndex--;
            } else {
              clearInterval(eraseInterval);
              setRoleIndex((prev) => (prev + 1) % roles.length);
            }
          }, 30);
        }, 1800);
      }
    }, 80);

    return () => clearInterval(typingInterval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleIndex]);

  const galleryImages = [
    { src: js, alt: "JavaScript" },
    { src: reactNative, alt: "React Native" },
    { src: darkMode ? iosDark : iosImg, alt: "iOS" },
    { src: androidIm, alt: "Android" },
    { src: react2, alt: "React 2" },
    { src: vue, alt: "Vue" },
    { src: csharp, alt: "C#" },
    { src: netCore, alt: ".NET Core" },
    // { src: java, alt: "Java" },
    { src: sql, alt: "SQL" },
    { src: androidImg, alt: "Android" },
    { src: jira, alt: "Jira" },
    { src: firebaseImg, alt: "Firebase" },
    { src: darkMode ? unityDark : unity, alt: "Unity" },
  ];

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollPosition = 0;
    const scrollSpeed = 1;
    let animationId;
    let isPaused = false;
    let isUserScrolling = false;
    let userScrollTimeout;

    const autoScroll = () => {
      // if (!isPaused && !isUserScrolling && scrollContainer) {
      if (!isPaused && scrollContainer) {
        scrollPosition += scrollSpeed;

        const maxScroll = scrollContainer.scrollWidth / 2;
        if (scrollPosition >= maxScroll) {
          scrollPosition = 0;
        }

        scrollContainer.scrollLeft = scrollPosition;
      }
      animationId = requestAnimationFrame(autoScroll);
    };

    const handleMouseEnter = () => {
      isPaused = true;
    };

    const handleMouseLeave = () => {
      isPaused = false;
    };

    const handleScroll = () => {
      isUserScrolling = true;
      scrollPosition = scrollContainer.scrollLeft;

      clearTimeout(userScrollTimeout);
      userScrollTimeout = setTimeout(() => {
        isUserScrolling = false;
      }, 1000);
    };

    const handleWheel = (e) => {
      e.preventDefault();
      scrollContainer.scrollLeft += e.deltaY;
      isUserScrolling = true;
      scrollPosition = scrollContainer.scrollLeft;

      clearTimeout(userScrollTimeout);
      userScrollTimeout = setTimeout(() => {
        isUserScrolling = false;
      }, 1000);
    };

    scrollContainer.addEventListener("mouseenter", handleMouseEnter);
    scrollContainer.addEventListener("mouseleave", handleMouseLeave);
    scrollContainer.addEventListener("scroll", handleScroll);
    scrollContainer.addEventListener("wheel", handleWheel, { passive: false });

    autoScroll();

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
      clearTimeout(userScrollTimeout);
      if (scrollContainer) {
        scrollContainer.removeEventListener("mouseenter", handleMouseEnter);
        scrollContainer.removeEventListener("mouseleave", handleMouseLeave);
        scrollContainer.removeEventListener("scroll", handleScroll);
        scrollContainer.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);
  return (
    <section id="home" className="min-h-screen rounded-xl mt-10">
      <div className="flex flex-col md:flex-row items-start justify-center justify-items-center">
        {/* Profile Card */}
        <div className="w-full flex flex-col items-center text-center bg-white dark:bg-black rounded-xl px-5 py-16 transition-colors duration-300">
          <img
            src={pPhoto}
            className="rounded-full shadow-xl w-[50%] h-[50%] mb-10"
            alt="Profile"
          ></img>
          <div className="w-full flex flex-col items-center">
            <div className="flex flex-row items-center mb-3 mt-4">
              <FaIdCard className="text-2xl text-purple-700 dark:text-purple-400 hover:text-gray-400 dark:hover:text-gray-300 transition duration-300 mr-2 mb-0 mt-1" />
              <p className="text-xl text-gray-700 dark:text-gray-300">
                Öznur Çaldıran
              </p>
            </div>
            <hr className="h-px bg-purple-400 dark:bg-purple-300 border-0 w-full max-w-xs" />
            <div className="flex flex-row items-center mt-2">
              <FaRegEnvelope className="text-2xl text-purple-700 dark:text-purple-400 hover:text-gray-400 dark:hover:text-gray-300 transition duration-300 mr-2" />
              <p className="text-sm text-gray-700 dark:text-gray-300">
                oznurcaldiran.dev@gmail.com
              </p>
            </div>
            <div className="flex flex-row items-center mb-3 mt-2">
              <FaMapMarkerAlt className="text-2xl text-purple-700 dark:text-purple-400 hover:text-gray-400 dark:hover:text-gray-300 transition duration-300 mr-1" />
              <p className="text-sm text-gray-700 dark:text-gray-300">
                Turkiye
              </p>
            </div>
            <hr className="h-px bg-purple-400 dark:bg-purple-300 border-0 w-full max-w-xs mt-3 mb-4" />
            <div className="flex flex-row items-center gap-4">
               <a
                href="https://linkedin.com/in/oznur-caldiran"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedin className="text-2xl text-gray-600 dark:text-gray-300 hover:text-blue-500 dark:hover:text-blue-400 transition duration-300" />
              </a>
               <a
                          href="https://medium.com/@oznur.dev"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaMedium className="text-2xl text-gray-600 dark:text-gray-300 hover:text-blue-400 dark:hover:text-blue-300 transition duration-300" />
                        </a>
              <a
                href="https://github.com/oznur-dev"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <FaGithub className="text-2xl text-gray-600 dark:text-gray-300 hover:text-purple-500 dark:hover:text-purple-400 transition duration-300" />
              </a>
            </div>
          </div>
        </div>

        {/* Introduction Card */}
        <div className="md:ml-10 mt-10 md:mt-0 w-full text-left bg-white dark:bg-black px-10 py-16 rounded-xl transition-colors duration-300 flex flex-col justify-center">
          <span className="inline-block mb-4 text-xs font-semibold tracking-widest uppercase text-purple-600 dark:text-purple-400">
            Welcome to my portfolio
          </span>

          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-800 dark:text-white leading-tight mb-4">
            Hello! I'm{" "}
            <span className="bg-gradient-to-r from-purple-600 to-blue-500 bg-clip-text text-transparent">
              Öznur.
            </span>
          </h1>

          <div className="flex items-center h-9 mb-6">
            <span className="text-xl font-mono text-gray-500 dark:text-gray-400">
              {displayedText}
              <span
                className="text-purple-500 dark:text-purple-400"
                style={{ animation: "blink 1s step-start infinite" }}
              >
                |
              </span>
            </span>
          </div>

          <p className="text-gray-600 dark:text-gray-400 text-base leading-relaxed mb-8 max-w-lg">
            I build responsive web apps, cross-platform mobile apps for iOS &
            Android, and Web APIs. I also plan projects using diagrams, charts, and graphs.
          </p>

          <style>{`
            @keyframes blink {
              0%, 100% { opacity: 1; }
              50% { opacity: 0; }
            }
          `}</style>

          <div className="flex flex-wrap gap-4">
            <a
              href="#contact"
              className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-full text-base px-8 py-2.5 transition-all duration-300"
            >
              Contact Me
            </a>
            <a
              href="#projects"
              className="text-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 hover:border-purple-500 dark:hover:border-purple-400 font-medium rounded-full text-base px-8 py-2.5 transition-all duration-300"
            >
              View Projects
            </a>
          </div>
        </div>
      </div>
      <div
        id="gallery"
        ref={scrollRef}
        className="w-full h-52 bg-white dark:bg-black rounded-xl mt-10 overflow-x-auto scrollbar-hide transition-colors duration-300 cursor-grab active:cursor-grabbing"
        style={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        onMouseDown={(e) => {
          const startX = e.pageX - scrollRef.current.offsetLeft;
          const scrollLeft = scrollRef.current.scrollLeft;

          const handleMouseMove = (e) => {
            const x = e.pageX - scrollRef.current.offsetLeft;
            const walk = (x - startX) * 2; // Scroll hızı
            scrollRef.current.scrollLeft = scrollLeft - walk;
          };

          const handleMouseUp = () => {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
          };

          document.addEventListener("mousemove", handleMouseMove);
          document.addEventListener("mouseup", handleMouseUp);
        }}
      >
        <div
          className="flex items-center h-full space-x-6 px-6"
          style={{ width: "max-content" }}
        >
          {[...galleryImages, ...galleryImages].map((image, index) => (
            <div
              key={index}
              className="flex-shrink-0 h-32 w-32 bg-gray-100 dark:bg-black rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-contain p-2"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Home;
